






import Vue from 'vue'
import logoLoader from '@/assets/svg/logo-loader.svg?inline'
export default Vue.extend<{}, {}, {}, {}>({
  components: {
    logoLoader,
  },
})
